<template>
  <Loading v-if="loading" />
  <Modal v-if="showModalEditSensor" @close="$emit('closeModal')">
    <div class="editSensor">
      <div class="editSensor__header">
        <span class="title">
          {{ $t('editSensor') }}
        </span>
        <img
          class="editSensor__header-img"
          src="@/assets/icons/CloseModal.svg"
          alt="Close Modal"
          @click="$emit('closeModal')"
        />
      </div>
      <FormKit
        id="editSensor-form"
        v-model="formData"
        type="form"
        :actions="false"
        @submit="submitHandler"
      >
        <div v-for="(el, index) in infoSensor" :key="index" class="infoSensor">
          <Input
            :type="el.type"
            :name="el.name"
            :label="$t(el.label)"
            :disabled="el.name === 'sn' || el.name === 'id'"
          />
        </div>
      </FormKit>
      <div class="editSensor__buttons">
        <Button variant="filled" :title="$t('save')" @click="editSensor" />
        <Button
          variant="bordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

import Loading from '@/views/Loading.vue';

import { infoSensor } from './configs';

import { DataUpdateSensor } from '@/store/modules/pharmacy/types';

@Options({
  name: 'EditSensor',
  emits: ['closeModal'],
  props: ['editSensorData', 'pharmacyId', 'showModalEditSensor'],
  components: {
    Loading
  },
  data() {
    return {
      formData: this.editSensorData,
      loading: false,
      infoSensor
    };
  },
  methods: {
    ...mapActions('pharmacy', ['updateSensor']),
    async submitHandler(data: DataUpdateSensor) {
      this.loading = true;

      const payload = {
        name: data.name,
        description: data.description,
        max: +data.max,
        min: +data.min
      };

      await this.updateSensor({
        data: payload,
        pharmacyId: this.pharmacyId,
        sensorId: this.editSensorData.id
      });

      this.$emit('closeModal');
      this.loading = false;
    },
    editSensor() {
      this.$formkit.submit('editSensor-form');
    }
  },
  watch: {
    editSensorData() {
      if (this.editSensorData) {
        this.formData = this.editSensorData;
      }
    }
  }
})
export default class EditSensor extends Vue {}
</script>

<style lang="scss" scoped>
.editSensor {
  max-width: 377px;
  width: 100%;
  height: 100%;
  padding: 24px;
  .editSensor__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    .createNewSensor__header-img {
      cursor: pointer;
    }
  }
  #editSensor-form {
    padding-top: 24px;
  }
  .editSensor__buttons {
    :first-child {
      margin-right: 12px;
    }
  }
}
</style>
